"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
const EnvironmentHelper_1 = require("../../helpers/EnvironmentHelper");
const LoggerHelper_1 = require("../../helpers/LoggerHelper");
const ALauncher_1 = require("../common/ALauncher");
class Launcher extends ALauncher_1.ALauncher {
    constructor() {
        super(...arguments);
        this.knownInAppBrowsers = [
            EnvironmentHelper_1.Browsers.Facebook,
        ];
    }
    _getLauncherUrl() {
        const conv = this.props.conversation;
        const sessionId = LoggerHelper_1.logger.getSessionId();
        if (EnvironmentHelper_1.os === EnvironmentHelper_1.OperatingSystems.Android) {
            return config_1.default.urls.launcher.intentUri(conv.action.toLowerCase(), conv.resource, sessionId, 'launcher', config_1.default.urls.app.downloadAndroid);
        }
        else if (EnvironmentHelper_1.os === EnvironmentHelper_1.OperatingSystems.iOS && this._isKnownInAppBrowser() && conv.shortId) {
            return config_1.default.urls.launcher.universalUri(conv.shortId);
        }
        return config_1.default.urls.launcher.skypeUri(conv.action.toLowerCase(), conv.resource, sessionId, 'launcher');
    }
    _getLoggerAction() {
        return 'join';
    }
    _isKnownInAppBrowser() {
        return this.knownInAppBrowsers.indexOf(EnvironmentHelper_1.browser) > -1;
    }
}
exports.Launcher = Launcher;
